import * as React from 'react';

import {
  Colors,
  Breakpoint,
  Lang,

  useDimensions,
  scrollToId,

  TextBlock,
  Confetti,

  Container,
  LargeContainer,
} from '@bluecurrent/web-component-lib';

import Setup from '../../config/setup';

import HasAlreadyReserved from '../Modules/HasAlreadyReserved';

export default function Landing(props) {
  const size = useDimensions();
  const { _ } = Lang.useTranslation();

  return (
    <LargeContainer>
      <div
        style={{
          height: 'auto',
          width: '100%',
          position: 'relative',
        }}
      >
        <Container
          share={[50, 50]}
          breakpoint={830}
        >
          <div
            style={{
              height: size.width < 830 ? '75vh' : '100%',
              maxHeight: 600,
              minHeight: 500,
              backgroundColor: Colors.GRADIENT,
              width: '100%',
              borderTopLeftRadius: size.width < Breakpoint.xxl ? 0 : 10,
              borderBottomLeftRadius: Setup.SUCCESS || size.width < Breakpoint.xxl ? 0 : 10,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              paddingLeft: size.width < 830 ? '3%' : '8%',
              paddingRight: size.width < 830 ? '3%' : '8%',
            }}
          >
            <TextBlock
              title={{
                content: props.title,
                fontFamily: 'Caveat',
                fontSize: '3.5em',
                fontWeight: 500,
                portableText: true,
              }}
              text={{
                content: Setup.SUCCESS ? '' : props.text,
                portableText: !Setup.SUCCESS,
              }}
              buttons={[
                {
                  id: 0,
                  customId: Setup.SUCCESS ? 'Button_LandingWatchVideo' : 'Button_DownloadPitchDeckLink',
                  text: Setup.SUCCESS ? _('invest.stayInformed', { ns: 'branding' }) : _('invest.downloadPitchDeck', { ns: 'branding' }),
                  size: 'medium',
                  onClick: () => {
                    scrollToId({
                      id: Setup.SUCCESS ? 'invest' : 'pitch-deck',
                      duration: 1500,
                    });
                  },
                  colorScheme: 'blue',
                },
              ]}
              align={size.width < 830 ? 'center' : 'left'}
            />
          </div>
          <div
            style={{
              height: size.width < 830 ? 1000 : '70vh',
              maxHeight: size.width < 830 ? 'auto' : 600,
              minHeight: 500,
              backgroundColor: size.width < 830 ? Colors.BLUE : Colors.GRADIENT,
              width: '100%',
              borderTopRightRadius: size.width < Breakpoint.xxl ? 0 : 10,
              borderBottomRightRadius: Setup.SUCCESS || size.width < Breakpoint.xxl ? 0 : 10,
              paddingLeft: size.width < 830 ? '3%' : '8%',
              paddingRight: size.width < 830 ? '3%' : '8%',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: size.width < 830 ? 'flex-start' : 'flex-end',
              position: 'relative',
            }}
          >
            {
              size.width < 830 && (
                <HasAlreadyReserved
                  amount={props.amount}
                  lastUpdate={props.lastUpdate}
                />
              )
            }
            <Confetti
              type="DotsPath"
              height={900}
              width={900}
              transform="scaleX(-1)"
              position="absolute"
              top={size.width < 400 ? -250 : -120}
              left={150}
              opacity={size.width < 830 ? 0.5 : 1}
            />
            <div
              style={{
                minHeight: 600,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                minWidth: 600,
                position: 'absolute',
              }}
            >
              <div
                style={{
                  height: size.width < 400 ? 410 : 450,
                  width: '100%',
                  backgroundImage: 'url("https://cdn.sanity.io/images/pnajo2cq/production/6a64b8f7f56e84ce9eab81c9914d928575ba49ba-1000x1000.png?w=600&h=600&auto=format&q=100")',
                  backgroundPosition: 'top right',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </div>
            <Confetti
              type="Figure"
              height={125}
              width={125}
              color={size.width < 830 ? Colors.YELLOW : Colors.GREEN}
              position="absolute"
              right="45%"
              bottom={30}
            />
          </div>
        </Container>
      </div>
      {
        size.width >= 830 && (
          <HasAlreadyReserved
            amount={props.amount}
            lastUpdate={props.lastUpdate}
          />
        )
      }
    </LargeContainer>
  );
}
